import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

import { SnAbilityService } from '@lib/ability';
import { SnWidget } from '@lib/api/entities';

import { EditContentDialogComponent } from '../../components';

@Component({
  selector: 'sn-content-widget',
  templateUrl: './content-widget.component.html',
  styleUrls: ['./content-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentWidgetComponent implements OnInit, OnDestroy {
  @Input() public widget: SnWidget;
  @Input() public viewId: string;
  @Output() public readonly widgetUpdated = new EventEmitter();

  public sanitizedContent;
  public changeTitle = false;
  public readonly canChange: boolean;
  private _destroy$ = new Subject();

  constructor(
    private readonly _matDialog: MatDialog,
    private readonly _cd: ChangeDetectorRef,
    private readonly _sanitizer: DomSanitizer,
    private readonly _ability: SnAbilityService,
  ) {
    this.canChange = this._ability.can({ subject: 'dashboards/widgetobject', action: 'change' });
  }

  public ngOnInit(): void {
    this.sanitizedContent = this._sanitizer.bypassSecurityTrustHtml(this.widget.content);
    this._cd.detectChanges();
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public edit(): void {
    const ref = this._matDialog.open(EditContentDialogComponent, { data: this.widget });

    ref
      .afterClosed()
      .pipe(takeUntil(this._destroy$))
      .subscribe((widget) => {
        this.widget = widget;
        this.sanitizedContent = this._sanitizer.bypassSecurityTrustHtml(this.widget.content);
        this.widgetUpdated.next(this.widget);
        this._cd.detectChanges();
      });
  }

  public editTitle(): void {
    this.changeTitle = true;
  }

  public setTitle(value: boolean): void {
    this.changeTitle = value;
    this._cd.detectChanges();
  }

  public setUpdateTitle(value: string): void {
    this.widget.name = value;
    this._cd.detectChanges();
  }
}
